import axios, { HttpStatusCode } from "axios";
import { StatusMessageResponse } from "../../../../common/interfaces/status-message-response";

export async function deleteAllMaintenancePoints(data: Array<any>, token: string): Promise<StatusMessageResponse> {
    try {
      const response = await axios.delete(process.env.REACT_APP_BASE_URL+'/manutencao/apontamento/all/ids/', 
        {
          data,
          headers: {
            Authorization: 'Bearer ' + token
          }
        }
      );
  
      const res = response.data; // Supondo que a resposta de criação seja retornado pelo backend
      return res;
    } catch (error) {
      return {
      statusCode: HttpStatusCode.InternalServerError,
      message: 'Falha ao deletar o apontamento de manutenção',
    }
    }
}

export async function deleteMaintenancePoint(id: string, token: string): Promise<StatusMessageResponse> {
  try {
    const response = await axios.delete(process.env.REACT_APP_BASE_URL+'/manutencao/apontamento/'+id, 
      {
        headers: {
          Authorization: 'Bearer ' + token
        }
      }
    );

    const res = response.data; // Supondo que a resposta de criação seja retornado pelo backend
    return res;
  } catch (error) {
    return {
      statusCode: HttpStatusCode.InternalServerError,
      message: 'Falha ao deletar os apontamentos de manutenção',
    }
  }
}